import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
// Types
import { ProjectAccrualPayloadType } from '@/api/types/request/ProjectAccrualPayloadType'
import { AccrualType } from '@/api/types/general/InvoiceType'
import { ProjectAccrualType } from '@/api/types/response/ProjectAccrualType'

/**
 * @property string apiEnd /api/sales/project/overview/{BidNumber}/accrual
 */
export default class ProjectAccrualApi extends AbstractApi {
  add(payload: ProjectAccrualPayloadType): Promise<ProjectAccrualType> {
    return httpClient.post(this.apiEnd, payload)
  }

  delete(payload: AccrualType): Promise<ProjectAccrualType> {
    return httpClient.delete(this.apiEnd, { data: payload })
  }
}
